<template><div><h1 id="kapitel-3-individual-fundraising" tabindex="-1"><a class="header-anchor" href="#kapitel-3-individual-fundraising"><span>Kapitel 3. Individual Fundraising</span></a></h1>
<p>Dieser Teil beinhaltet die Module und Funktionen des individual Fundraising.</p>
</div></template>


